



























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({})
export default class PageHeader extends Vue {

    private breadcrumb: boolean = false;

    private logo: boolean = false;

    private action: boolean = true;

    @Prop({type: Boolean, default: true})
    private extra: boolean = true;

    @Prop({type: String, default: null})
    private title!: string;

    @Prop({type: String, default: null})
    private content!: string;

    private titleTpl: string = '';
}
